import { Injectable } from '@odinjs/odin';
import { FileService } from '@philips-internal/oswald-ui-components';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { SLARoutesAPI } from '../constants';
import { ChartFilter } from '../interfaces';

@Injectable({})
export class SlaService {

  static download(id: number, fileName: string): Promise<Blob> {
    return FileService.download(SLARoutesAPI.SLA_DOWNLOAD,
      fileName,
      { id });
  }

  static getTotalTarget(filter: ChartFilter | undefined): Promise<string> {
    return HttpService.get(SLARoutesAPI.SLA_TOTAL_TARGET, filter)
      .then(response => {
        return response.body as string;
      });
  }

  static getTotalReached(filter: ChartFilter | undefined): Promise<string> {
    return HttpService.get(SLARoutesAPI.SLA_TOTAL_REACHED, filter)
      .then(response => {
        return response.body as string;
      });
  }
}
